import { Button, H4, Space } from '@gr-monorepo/common/ui/ui';
import { PopupsApi } from 'api';
import { useClickStreamContext } from 'features/shared/ClickStream';
import Modal from 'features/shared/Modal';
import useUserData from 'hooks/useUserData';
import React, { useContext, useEffect } from 'react';
import styled from 'styled-components/macro';
import { OnboardingContext } from './OnboardingContext';
import { useHistory } from 'react-router-dom';
import { useSurveysContext } from 'features/surveys/SurveysContext';

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
`;

const surveyName = 'survey_about_reports_in_cabmun';
const surveyTitle = 'Excel-отчеты в разделах Школы и Олимпиады';

const SurveyAboutReportsInCabmunInner = () => {
  const userData = useUserData();
  const context = useContext(OnboardingContext);
  let history = useHistory();
  const { logPageEvent } = useClickStreamContext();
  const { setShowTooltip } = useSurveysContext();
  const close = async () => {
    context.saveLog();
    await PopupsApi.loggedShowPopup(55, { subjectId: userData?.id || 0 });
  };

  const overflowClick = () => {
    logPageEvent({
      eventType: surveyName + '_click_overflow',
      eventInfo: `Опрос|${surveyTitle}: Клик вне попапап`,
    });
    close();
    setShowTooltip(true);
  };

  const goClick = () => {
    logPageEvent({
      eventType: surveyName + '_click_to_go',
      eventInfo: `Опрос|${surveyTitle}: Клик по кнопке Пройти`,
    });
    close();
    history.push('/surveys');
  };

  const cancelClick = () => {
    logPageEvent({
      eventType: surveyName + '_click_to_cancel',
      eventInfo: `Опрос|${surveyTitle}: Клик по кнопке Отложить`,
    });
    close();
    setShowTooltip(true);
  };

  useEffect(() => {
    logPageEvent({
      eventType: surveyName + '_show_popup',
      eventInfo: `Опрос|${surveyTitle}: показан попап`,
    });
  }, []);

  return (
    <>
      <Modal onClose={overflowClick}>
        <H4 style={{ textAlign: 'center' }}>Пройдите опрос</H4>
        <Space size={16} axis="vertical" />
        <div style={{ width: 506, fontSize: '20px', lineHeight: '28px' }}>
          Просим пройти опрос об Excel-отчетах из разделов «Школы» и «Олимпиады», чтобы сделать сервис ещё удобнее.
        </div>
        <Space size={40} axis="vertical" />
        <Buttons>
          <Button color="light_green" style={{ width: 184 }} onClick={cancelClick}>
            отложить
          </Button>
          <Space size={24} />
          <Button color="green" style={{ width: 184 }} onClick={goClick}>
            Пройти
          </Button>
        </Buttons>
        <Space size={16} axis="vertical" />
      </Modal>
    </>
  );
};

const SurveyAboutReportsInCabmun = () => {
  const context = useContext(OnboardingContext);
  const showOnboarding = context.onboardingName === 'surveyAboutReportsInCabmun';
  if (!showOnboarding) return <></>;

  return <SurveyAboutReportsInCabmunInner />;
};

export default SurveyAboutReportsInCabmun;
